/*
 *
 * PagoPaDownloadAllPopup
 *
 * @version 1.0.0
 * @author Emanuele Motta
 * @since 10-Dec-2025
*/

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import PagoPaDownloadAllPopup from './PagoPaDownloadAllPopup'
import * as PagoPaActions from '../../routes/PagoPa/modules/PagoPaActions'
import { doHidePopup } from 'Store/actions/popup'
import { nullSafe } from 'Utility/globalMethods'

const mapDispatchToProps = dispatch => ({
  ...bindActionCreators(PagoPaActions, dispatch),
  ...bindActionCreators({ doHidePopup }, dispatch)
})

const mapStateToProps = (state) => ({
  isDownloadLoading: nullSafe(() => state.loading.localLoading.download_all_transactions, false),
  fromDate: nullSafe(() => state.popup.popupInfo.fromDate, ''),
  toDate: nullSafe(() => state.popup.popupInfo.toDate, ''),
  terminals: nullSafe(() => state.popup.popupInfo.terminals, []),
  minAmount: nullSafe(() => state.popup.popupInfo.minAmount, 0),
  maxAmount: nullSafe(() => state.popup.popupInfo.maxAmount, 10000),
  iuv: nullSafe(() => state.popup.popupInfo.iuv, ''),
  stateCompany: nullSafe(() => state.popup.popupInfo.stateCompany, ''),
  fileFormat: nullSafe(() => state.popup.popupInfo.fileFormat, 'EXCEL'),
  customPeriod: nullSafe(() => state.popup.popupInfo.customPeriod, null),
  transactionType: nullSafe(() => state.popup.popupInfo.transactionType, '')
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(PagoPaDownloadAllPopup)
